// Small drawings for the help cards that need no settings.

/** A bank card lying on its outline, the outline slightly too big (as a magnifier makes it). */
export function CardOutlineMini() {
  return (
    <svg viewBox="0 0 480 150" role="img" aria-label="A card held against its outline on the screen; with a magnifier on, the outline looks bigger than the card">
      <rect x="40" y="20" width="171" height="108" rx="7" fill="#e9eef5" stroke="#5b6b7b" strokeWidth="2" />
      <rect x="40" y="20" width="171" height="108" rx="7" fill="none" stroke="#d97706" strokeWidth="3" />
      <text x="40" y="145" fontSize="11" fill="#1f2a35">matches: true size</text>
      <rect x="270" y="20" width="171" height="108" rx="7" fill="#e9eef5" stroke="#5b6b7b" strokeWidth="2" />
      <rect x="262" y="14" width="199" height="125" rx="8" fill="none" stroke="#d97706" strokeWidth="3" />
      <text x="262" y="147" fontSize="11" fill="#c92a2a">outline 16% too big: magnified</text>
    </svg>
  );
}
